import { ThemedStyledProps } from "../styled"
import { breakpoints, Breakpoint } from "./breakpoints"
import { coerceArray } from "../utils"
import { px } from "../units"
import { curry } from "ramda"

const offset = 0.05

const sortBreakpoints = (bps: Breakpoint[]) =>
  bps.sort((a, b) => breakpoints.indexOf(a) - breakpoints.indexOf(b))

const up = curry(
  (breakpoint: Breakpoint, { theme }: ThemedStyledProps<{}>) =>
    `@media (min-width:${px(theme.breakpoints[breakpoint])})`
)

const down = curry(
  (breakpoint: Breakpoint, { theme }: ThemedStyledProps<{}>) => {
    const endIndex = breakpoints.indexOf(breakpoint) + 1

    if (endIndex === breakpoints.length) {
      // applies to all sizes
      return up(breakpoints[0], { theme })
    }

    return `@media (max-width:${px(
      theme.breakpoints[breakpoints[endIndex]] - offset
    )})`
  }
)

const between = curry(
  (
    [start, end]: [Breakpoint, Breakpoint],
    { theme }: ThemedStyledProps<{}>
  ) => {
    const endIndex = breakpoints.indexOf(end) + 1

    if (endIndex === breakpoints.length) {
      return up(start, { theme })
    }

    return (
      `@media (min-width:${px(theme.breakpoints[start])}) and ` +
      `(max-width:${px(theme.breakpoints[breakpoints[endIndex]] - offset)})`
    )
  }
)

const only = curry(
  (breakpoint: Breakpoint | Breakpoint[], { theme }: ThemedStyledProps<{}>) => {
    const bps = sortBreakpoints(coerceArray(breakpoint))
    return between([bps[0], bps[bps.length - 1]], { theme })
  }
)

export { up, down, between, only, sortBreakpoints }
